import React from 'react';
import {Dimmer, Loader} from 'semantic-ui-react';
import {css} from 'emotion';
import styled from 'react-emotion';
import types from 'prop-types';
import {colors} from '../../styles';

const DimmableWrapper = styled(({center, ...rest}) => (
  <Dimmer.Dimmable {...rest} />
))`
  padding: 0 0 20px;
  background: #fff;
  margin-bottom: 10px;
  min-height: 100px;
  margin-top: 50px;

  h1.ui.header {
    margin-bottom: 40px;
    font-size: 1.3rem;
    font-weight: normal;

    .sub.header {
      font-size: 0.9rem;
      color: ${colors.textLabel};
    }
  }

  h2.ui.header {
    font-weight: normal;
  }

  ${props =>
    props.center &&
    css`
      display: flex;
      justify-content: center;
      align-items: center;
    `};
`;

const FormContainer = ({children, loading, ...props}) => {
  return (
    <DimmableWrapper dimmed={loading} {...props}>
      {children}
      <Dimmer active={loading} inverted>
        <Loader>Loading...</Loader>
      </Dimmer>
    </DimmableWrapper>
  );
};

FormContainer.propTypes = {
  children: types.node.isRequired,
  /** Show a loading indicator */
  loading: types.bool,
  /** Center the component vertically and horizontally using flexbox */
  center: types.bool,
};

FormContainer.displayName = 'FormContainer';

export default FormContainer;
